import React from "react";
import { Link } from "react-router-dom";
import "../styles/saas.css";

export default function PaymentFailurePage() {
  return (
    <div className="saas-page saas-auth">
      <h1>Payment failed</h1>
      <p>We could not process your payment. Please try again.</p>
      <Link to="/saas/subscription" className="saas-btn saas-btn--primary">Try again</Link>
    </div>
  );
}
